import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));

// Detect Edge and render without StrictMode to prevent potential double-rendering issues
const isEdge = navigator.userAgent.indexOf('Edg') > -1;

if (isEdge) {
  root.render(<App />);
} else {
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}
